import type { ApiError } from "@circle-react/config/CustomErrors";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useQuery } from "react-query";

import type { Profile } from "@/react/types/CommunityBot/Profile";

const AI_AGENT_PROFILE_INFO_QUERY_KEY = "AI_AGENT_PROFILE_INFO";

export interface AgentProfileResponse {
  avatar_url?: string;
  bio?: string;
  can_interact?: boolean;
  comments_count?: number;
  id: number;
  is_deleted: boolean;
  name: string;
  profile?: Profile;
  type: "CommunityAiAgent";
}

export const useAgentProfileInfo = ({
  agentId,
  params = {},
}: {
  agentId: number;
  params?: Record<string, unknown>;
}) => {
  const queryKey = [AI_AGENT_PROFILE_INFO_QUERY_KEY, agentId, params];

  const fetchCommunityAiAgentProfileInfo = () =>
    reactQueryGet(
      internalApi.communityAiAgentProfile.show({ agentId, params }),
    );

  const getAgentProfileInfoQuery = useQuery<AgentProfileResponse, ApiError>({
    queryKey,
    queryFn: fetchCommunityAiAgentProfileInfo,
    retry: false,
    enabled: Boolean(agentId),
  });

  return {
    getAgentProfileInfoQuery,
  };
};
